import { useFetcherData } from "v2/hooks/useFetcherData";
import { FetcherKeys } from "routes/dataroutes/Fetchers";
import { CountersData } from "pages/dashboard/PlanOverviewAndStatsCard";
import { useEffect } from "react";


export const COUNTERS_FETCHER_HREF = "/billing-data/counters";

export function useCounters(opts?: { reloadOnFocus?: boolean }) {
  const { value, fetcher, reload } = useFetcherData<CountersData>({
    fetcherKey: FetcherKeys.COUNTERS,
    fetcherHref: COUNTERS_FETCHER_HREF,
    reloadOnFocus: opts?.reloadOnFocus ?? false,
  });

  // TODO not sure what's the purpose of this block
  useEffect(() => {
    if (fetcher?.data) {
      reload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Treat the pre-fetch window (idle state, no data yet) as loading too — otherwise
  // consumers briefly render their fallback values before the counters arrive.
  const loading = !value && !fetcher?.data;

  return {
    counters: value,
    loading,
    fetcher,
    refreshCounters: reload,
  };
}
